import { useContext } from "react";
import AlertContext from "../context/alert/AlertContext";
import ConfigContext from "../context/config/ConfigContext";
import { useLocation } from "react-router-dom";

const useAlert = () => {
  const alertContext = useContext(AlertContext);
  const configContext = useContext(ConfigContext);
  const { clearAlerts, setAlertTarget } = alertContext;
  const { getConfigValueByCode } = configContext;
  //   const [status, setStatus] = useState(false);

  const location = useLocation();

  const updateStatus = (response) => {
    console.log("$$RES::", response);
    let msg = "";
    if (response.msgCode && response.status) {
      msg = getConfigValueByCode(
        "generalConfig",
        "RESPONSE_MSG",
        response.msgCode
      );
    } else if (response.errorMessage) {
      msg = response.errorMessage;
    } else if (!response.msgCode && response.status !== "SUCCESS") {
      msg = `Response Missing ${!response.status ? "status" : ""} ${
        !response.msgCode ? " Code" : ""
      }`;
      // setStatus(true);
    }
    if (!msg && response.status === "ERROR") {
      msg = "Unexpected Error Occured.";
    }
    //    else {
    //       setStatus(true);
    //     }
    clearAlerts();
    console.log(
      "RESPONSE STATUS ",
      response.status,
      " CHECK",
      response.status === "ERROR"
    );
    if (msg)
      setAlertTarget(
        msg,
        response.status === "ERROR" ? "danger" : "success",
        location.pathname
      );
    return !response.status || response.status === "ERROR" ? false : true;
  };

  return [updateStatus];
};

export default useAlert;
